export const LAYERS = {
    POPUP: 'POPUP',
    WIDGET: 'WIDGET'
};
